// Librerias
import React from 'react'
import api from '../../apiClient/v1'
let PropTypes = React.PropTypes
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
import { FormularioUsuario } from './FormularioUsuario.jsx'
import { ZoomImagen } from '../../components/ZoomImagen/ZoomImagen.jsx'
import { InputRun } from '../../shared/input/InputRun.jsx'
// Notify
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
// Style
import classNames from 'classnames/bind'
import * as css from './modal.css'
let cx = classNames.bind(css)

// function as a children FTW! :D
export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = {visible: false}
        let self = this
        this.show = ()=>
            self.setState({visible: true})
        this.hide = ()=>{
            self.setState({visible: false})
        }
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalAgregarUsuario extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            usuario: {
                id: 0,
                usuarioRUN: '',
                usuarioDV: '',
                nombre1: '',
                nombre2: '',
                apellidoPaterno: '',
                apellidoMaterno: '',
                email: '',
                emailPersonal: '',
                telefono: '',
                telefonoEmergencia: '',
                fechaNacimiento: '0000-00-00',
                sexo: '',
                nacionalidad: '',
                direccion: '',
                cutComuna: 7301,
                tipoContrato: '',
                banco: '',
                tipoCuenta: '',
                numeroCuenta: ''
            }
        }
        this.nuevoUsuario = (datos)=>{
            let banco = this.props.datosbancos.bancos.find( banco => banco.nombreCorto == datos.banco)
            let tipoCuenta = this.props.datosbancos.tipo_cuentas.find( cuenta => cuenta.nombreCuenta == datos.tipoCuenta)
            datos.banco = banco.idBanco;
            datos.tipoCuenta = tipoCuenta.idCuenta;
            api.usuarios.nuevoUsuario(datos)
                .then(resp=>{
                    this.props.hideModal()
                })
                .catch(err=>{
                    console.log(err)
                    let errores = err.data
                    let mensaje = '';
                    for (const i in errores) {
                        mensaje += i+": "+errores[i][0]+'\n'
                    }
                    alert(errores);
                })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')} dialogClassName={cx('modalUser')}>
                <Modal.Header closeButton>
                    <Modal.Title>Nuevo usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormularioUsuario
                        usuario={this.state.usuario}
                        enviarFormulario={this.nuevoUsuario}
                        cancelarFormulario={this.props.hideModal}
                        comunas={this.props.comunas}
                        bancos = {this.props.datosbancos.bancos}
                        tiposcuentas = {this.props.datosbancos.tipo_cuentas}
                        btnTexto={"Guardar"}
                    />
                </Modal.Body>
            </Modal>
        )
    }
}
export class ModalEditarUsuario extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            usuario: this.props.usuario
        }
        this.editarUsuario = (datos)=>{
            let banco = this.props.datosbancos.bancos.find( banco => banco.nombreCorto == datos.banco)
            let tipoCuenta = this.props.datosbancos.tipo_cuentas.find( cuenta => cuenta.nombreCuenta == datos.tipoCuenta)
            datos.banco = banco.idBanco;
            datos.tipoCuenta = tipoCuenta.idCuenta;
            api.usuario(this.state.usuario.id).actualizar(datos)
                .then(resp=>{
                    this.props.fetchUsuarios()
                    this.props.hideModal()
                })
                .catch(err=>{
                    console.log(err)
                })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')} dialogClassName={cx('modalUser')}>
                <Modal.Header closeButton>
                    <Modal.Title>Editando a : {this.state.usuario.nombre1} {this.state.usuario.apellidoPaterno}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormularioUsuario
                        usuario={this.state.usuario}
                        enviarFormulario={this.editarUsuario}
                        cancelarFormulario={this.props.hideModal}
                        comunas={this.props.comunas}
                        bancos = {this.props.datosbancos.bancos}
                        tiposcuentas = {this.props.datosbancos.tipo_cuentas}
                        btnTexto={"Modificar"}
                    />
                </Modal.Body>
            </Modal>
        )
    }
}
export class ModalBloquearCliente extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            // CMT POR DEFECTO
            cliente: 7,
            usuario: this.props.usuario,
            clientes: this.props.clientes,
            error: {},
            isChecked:false
        }
        this.fetchEstado = (cliente)=>{
            api.nominas.getEstado(this.state.usuario.id, cliente)
                .then(estado=>{
                    this.setState({isChecked: estado})
                })
                .catch(meh=>{})
        }
        this.onInputChange = (key, evt)=>{
            let actualizado = {}
            const target = evt.target;
            //actualizado[key] = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
            actualizado[key] = target.value
            this.setState({ usuario: Object.assign({}, this.state.usuario, actualizado)})
            this.setState({
               [target.name]: actualizado[key]
            }, ()=>this.fetchEstado(this.state.cliente));
        }
        this.onCheckChange = (key, evt)=>{
            let actualizado = {}
            const target = evt.target;
            actualizado[key] = target.checked
            this.setState({ usuario: Object.assign({}, this.state.usuario, actualizado)})
            this.setState({
                [target.name]: actualizado[key]
            });
        }
        this.handleSubmit = (evt)=>{
            evt.preventDefault()
            evt.stopPropagation()

            this.setState({error: {}}, ()=>{
                this.props.bloquearUsuarioCliente(this.state.usuario.id, this.state.usuario)
                    .then(()=>{
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        this.setState({error: error.data})
                    })
            })
        }
    }
    componentWillMount(){
        //CLIENTE CMT POR DEFECTO
        this.fetchEstado(this.state.cliente)
    }
    render(){
        return(
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Bloqueando por cliente a : {this.state.usuario.nombre1} {this.state.usuario.apellidoPaterno} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-inline" onSubmit={this.handleSubmit}>
                        <div className={cx('form-group', 'selectCliente')}>
                            <label>Seleccionar Cliente</label>
                            <select className="form-control"
                                    name="cliente"
                                    onChange={this.onInputChange.bind(this, 'idCliente')}
                                    value={this.state.cliente}
                            >
                                {this.props.clientes.map(cliente=>
                                    <option key={cliente.idCliente} value={cliente.idCliente}>{cliente.nombreCorto}</option>
                                )}
                            </select>
                        </div>
                        <div className="checkbox">
                            <label>
                                <input type="checkbox" name="isChecked" checked={this.state.isChecked} onChange={this.onCheckChange.bind(this, 'estado')}/>  Bloquear?
                            </label>
                        </div>
                        <button type="submit" className="btn btn-danger">Aceptar</button>
                        <button className="btn btn-default" onClick={this.props.hideModal}>Cancelar</button>
                    </form>

                </Modal.Body>
            </Modal>
        )
    }
}

export const ModalBloquearUsuario = ({hideModal, onBloquear})=>
    <Modal show={true} onHide={hideModal} className={cx('modal')}>
        <Modal.Header closeButton>
            <Modal.Title>¿Esta seguro que desea bloquear al usuario?</Modal.Title>
        </Modal.Header>
        <Modal.Footer className={cx('bloquearUsuario_footer')} >
            <button className="btn btn-block btn-default" onClick={hideModal}>Cancelar</button>
            <button className="btn btn-block btn-danger" onClick={onBloquear}>Bloquear usuario</button>
        </Modal.Footer>
    </Modal>

export const ModalDesbloquearUsuario = ({hideModal, onDesbloquear})=>
    <Modal show={true} onHide={hideModal} className={cx('modal')}>
        <Modal.Header closeButton>
            <Modal.Title>¿Esta seguro que desea desbloquear al usuario?</Modal.Title>
        </Modal.Header>
        <Modal.Footer className={cx('bloquearUsuario_footer')} >
            <button className="btn btn-block btn-default" onClick={hideModal}>Cancelar</button>
            <button className="btn btn-block btn-success" onClick={onDesbloquear}>Desbloquear usuario</button>
        </Modal.Footer>
    </Modal>

export const ModalApproveFiles = ({hideModal, onApproveFiles, statusFiles})=>
    <Modal show={true} onHide={hideModal} className={cx('modal')}>
        <Modal.Header closeButton>
            <Modal.Title>¿Esta seguro de {statusFiles === 'Aprobados'? 'DESAPROBAR ' : 'APROBAR ' } la documentación del usuario?</Modal.Title>
        </Modal.Header>
        <Modal.Footer className={cx('bloquearUsuario_footer')} >
            <button className="btn btn-block btn-default" onClick={hideModal}>Cancelar</button>
            <button className="btn btn-block btn-success" onClick={onApproveFiles}>Aceptar</button>
        </Modal.Footer>
    </Modal>

export const ModalCambiarContrasena = ({hideModal, onAceptar})=>{
    let refContrasena = null
    const onCambiar = ()=>{
        onAceptar(refContrasena.value)
    }
    return (
        <Modal show={true} onHide={hideModal} className={cx('modal')}>
            <Modal.Header closeButton>
                <Modal.Title>Cambio de contraseña</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form-horizontal">
                    <div className="form-group">
                        <label htmlFor="password" className="col-sm-2 control-label">Contraseña</label>
                        <div className="col-xs-10">
                            <input className="form-control" type="text"
                                   ref={ref=> refContrasena=ref}
                                   onKeyDown={evt=>{
                                       if(evt.keyCode==13){
                                           onCambiar()
                                           evt.preventDefault()
                                           return
                                       }
                                   }}
                            />
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className={cx('cambiarContrasena_footer')} >
                <button className="btn btn-block btn-default" onClick={hideModal}>Cancelar</button>
                <button className="btn btn-block btn-success" onClick={onCambiar}>Cambiar</button>
            </Modal.Footer>
        </Modal>
    )
}
export class ModalUploadFiles extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            frontDNI: '',
            backDNI: '',
            certificatePersonalHistory: '',
            contract: '',
            credential: '',
            completededDocumentation: this.props.statusFiles === 'Cargados',
            existingContract: this.props.user.existingContract,
            existingCarnetFront: this.props.user.existingCarnetFront,
            existingCarnetBack: this.props.user.existingCarnetBack,
            existingCertificateA: this.props.user.existingCertificateA,
            existingCredential: this.props.user.existingCredential,
        }
        this.onChangeDNIFront = (evt) => {
            this.setState({
                frontDNI: evt.target.files[0]
            }, ()=> this.context.uploadDNIFront(this.props.idUsuario, this.state.frontDNI))
        }
        this.onChangeDNIBack = (evt) => {
            this.setState({
                backDNI: evt.target.files[0]
            }, ()=> this.context.uploadDNIBack(this.props.idUsuario, this.state.backDNI))
        }
        this.onChangeCertificate = (evt) => {
            this.setState({
                certificatePersonalHistory: evt.target.files[0]
            }, ()=> this.context.uploadCertificate(this.props.idUsuario, this.state.certificatePersonalHistory))
        }
        this.onChangeContract = (evt) => {
            this.setState({
                contract: evt.target.files[0]
            }, ()=> this.context.uploadContract(this.props.idUsuario, this.state.contract))
        }
        this.onChangeCredential = (evt) => {
            this.setState({
                credential: evt.target.files[0]
            }, ()=> this.context.uploadCredential(this.props.idUsuario, this.state.credential))
        }
        this.onChangeProgress = () => {
            let status = !this.state.completededDocumentation
            let request = this.context.progressStatusDocumentation(this.props.idUsuario, status)
            request
                .then(files => {
                    this.setState({completededDocumentation: status})
                })
                .catch(()=>{
                    console.log("error")
                })
        }
    }
    render(){
        return(
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Subiendo archivos de usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        <div className={cx('btn-group-vertical', 'div-option-file')}>
                            <button className={cx(this.state.existingCertificateA? 'btn btn-success' : 'btn btn-warning', 'btn-file')} disabled={this.state.completededDocumentation}>
                                {this.state.existingCertificateA? 'Reemplazar ' : 'Subir '}Certificado Antecedentes<input type="file" onChange={this.onChangeCertificate}/>
                            </button>
                            <button className={cx(this.state.existingCarnetFront? 'btn btn-success' : 'btn btn-warning', 'btn-file')} disabled={this.state.completededDocumentation}>
                                {this.state.existingCarnetFront? 'Reemplazar ' : 'Subir '}Carnet Frontal<input type="file" onChange={this.onChangeDNIFront}/>
                            </button>
                            <button className={cx(this.state.existingCarnetBack? 'btn btn-success' : 'btn btn-warning', 'btn-file')} disabled={this.state.completededDocumentation}>
                                {this.state.existingCarnetBack? 'Reemplazar ' : 'Subir '}Carnet Posterior<input type="file" onChange={this.onChangeDNIBack}/>
                            </button>
                            <button className={cx(this.state.existingContract ? 'btn btn-success': 'btn btn-warning', 'btn-file')} disabled={this.state.completededDocumentation}>
                                {this.state.existingContract? 'Reemplazar ' : 'Subir '}Contrato PDF<input type="file" onChange={this.onChangeContract}/>
                            </button>
                            <button className={cx(this.state.existingCredential? 'btn btn-success' : 'btn btn-warning', 'btn-file')} disabled={this.state.completededDocumentation}>
                                {this.state.existingCredential? 'Reemplazar ' : 'Subir '}Fotografía Credencial<input type="file" onChange={this.onChangeCredential}/>
                            </button>
                            <button className={this.state.completededDocumentation? 'btn btn-success' : 'btn btn-warning'} onClick={this.onChangeProgress}>
                                {this.state.completededDocumentation? 'Publicado' : 'Pendiente de publicación'}
                            </button>
                        </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-btn-default" onClick={this.props.hideModal}>Cerrar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalUploadFiles.contextTypes = {
    uploadDNIFront: PropTypes.func,
    uploadDNIBack: PropTypes.func,
    uploadCertificate: PropTypes.func,
    uploadContract: PropTypes.func,
    uploadCredential: PropTypes.func,
    progressStatusDocumentation: PropTypes.func
}
export class ModalReviewFiles extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            index: 0,
            files: [],
            user: this.props.user
        }
        this.onRutChange = (usuarioRUN, usuarioDV) => {
            this.ref_usuarioDV.value = usuarioDV
            let updated = {}
            updated['usuarioRUN'] = usuarioRUN
            updated['usuarioDV'] = usuarioDV
            updated['edit'] = 1
            this.setState({ user: Object.assign({}, this.state.user, updated)})
        }
        this.onInputChange = (key, evt) => {
            let updated = {}
            updated[key] = evt.target.value
            updated['edit'] = 1
            this.setState({ user: Object.assign({}, this.state.user, updated)})
        }
        this.onIsWrong = (evt) => {
            let status = evt.target.checked
            let idFile = this.state.files[this.state.index].idFileUser
            let request = this.context.isWrongFile(idFile, status)
            request
                .then(resp => {
                    this.refs.notificator.success('Actualización',  'Se ha actualizado correctamente', 2*1000)
                    this.getDocumentation()
                })
                .catch(()=>{
                    this.refs.notificator.error('Actualización', 'Surgieron problemas en la actualización', 4*1000)
                })
        }
        this.onDeleteFile = () => {
            let idFile = this.state.files[this.state.index].idFileUser
            let request = api.documentUser(idFile).deleteFile()
            request
                .then(resp => {
                    this.setState({index: 0})
                    this.getDocumentation()
                })
                .catch(()=>{
                    console.log("error")
                })
        }
        this.getDocumentation = () => {
            let request = api.usuario(this.props.user.id).getDocumentation()
            request
                .then(files => {
                    this.setState({files})
                })
                .catch(()=>{
                    console.log("error")
                })
        }
        this.handleSubmit = () => {
            if(this.state.user.edit){
                api.usuario(this.state.user.id).actualizar(this.state.user)
                    .then(resp=>{
                        this.refs.notificator.success('Actualización',  'Usuario actualizado correctamente', 2*1000)
                    })
                    .catch(err=>{
                        this.refs.notificator.error('Actualización', 'Surgieron problemas en la actualización', 4*1000)
                    })
            }
        }
        this.nextFile = () => {
            this.setState({
                index: this.state.index<(this.state.files.length-1)? this.state.index+1 : this.state.index
            })
        }
        this.previusFile = () => {
            this.setState({
                index: this.state.index>0? this.state.index-1 : this.state.index
            })
        }
        this.onKeyPressed = (evt) => {
            switch (evt.key) {
                case "ArrowLeft":
                    this.previusFile();
                    break;
                case "ArrowRight":
                    this.nextFile();
                    break;
            }
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.onKeyPressed);
        this.getDocumentation();
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.onKeyPressed);
    }
    render(){
        return(
            <Modal show={true} onHide={this.props.hideModal} dialogClassName={cx('modalReviewFiles')} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {`Revisando documentación de ${this.props.user.nombre1} ${this.props.user.apellidoPaterno}, RUT: ${this.props.user.usuarioRUN}-${this.props.user.usuarioDV}`}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.files.length > 0 ?
                        <div className="row">
                            <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                            {this.state.files[this.state.index].name_document === 'Carnet frontal' ?
                                <div className="col-md-12">
                                    <div className="col-md-6">
                                        <div className="col-md-12">
                                            <h5 className={css.textInfo}>Tipo Documento: {this.state.files[this.state.index].name_document}</h5>
                                        </div>
                                        <div className="col-md-6">
                                            <ZoomImagen
                                                ruta_imagen={this.state.files[this.state.index].path}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <nav aria-label="...">
                                                <ul className="pager">
                                                    <li>
                                                        <a className={css.btnModal} onClick={() => this.previusFile()}>
                                                            <span className="glyphicon glyphicon-arrow-left" aria-hidden="true"/>
                                                            Anterior
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a className={css.btnModal} onClick={() => this.nextFile()}>
                                                            Siguiente
                                                            <span className="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <h5>&nbsp;</h5>
                                    </div>
                                    <div className="col-md-5 col-md-offset-1">
                                        {/* RUT */}
                                        <div className={cx('col-md-12 form-group', 'form__control-label')}>
                                                <label className="col-sm-3 control-label">RUT</label>
                                            <div className="col-sm-6">
                                                <InputRun key={1}
                                                          onRUNChange={this.onRutChange}
                                                          rut={this.state.user.usuarioRUN}
                                                          className={'form-control'}
                                                />
                                            </div>
                                            <div className="col-sm-3">
                                                <input ref={ref =>  this.ref_usuarioDV = ref } value={this.state.user.usuarioDV} type="text" className="form-control" disabled/>
                                            </div>     
                                        </div>
                                        {/* NOMBRES */}
                                        <div className={cx('col-md-12 form-group', 'form__control-label')}>
                                            <label className="col-sm-3 control-label">Nombres</label>
                                            <div className="col-sm-8 col-md-4">
                                                <input
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Primer nombre"
                                                    onChange={this.onInputChange.bind(this, 'nombre1')}
                                                    value={this.state.user.nombre1}
                                                />
                                            </div>
                                            <div className="col-sm-8 col-md-4">
                                                <input 
                                                    type="text" className="form-control" 
                                                    placeholder="Segudo Nombre"
                                                    onChange={this.onInputChange.bind(this, 'nombre2')}
                                                    value={this.state.user.nombre2}
                                                />
                                            </div>
                                        </div>
                                        {/* APELLIDOS */}
                                        <div className={cx('col-md-12 form-group', 'form__control-label')}>
                                            <label className="col-sm-3 control-label">Apellidos</label>
                                            <div className="col-sm-8 col-md-4">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Apellido Paterno"
                                                    onChange={this.onInputChange.bind(this, 'apellidoPaterno')}
                                                    value={this.state.user.apellidoPaterno}
                                                />
                                            </div>
                                            <div className="col-sm-8 col-md-4">
                                                <input type="text" 
                                                       className="form-control" 
                                                       placeholder="Apellido Materno"
                                                       onChange={this.onInputChange.bind(this, 'apellidoMaterno')}
                                                       value={this.state.user.apellidoMaterno}
                                                />
                                            </div>
                                        </div>
                                        {/* FECHA NACIMIENTO */}
                                        <div className={cx('col-md-12 form-group', 'form__control-label')}>
                                            <label className="col-sm-3 control-label">Nacimiento</label>
                                            <div className="col-sm-8 col-md-7">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    onChange={this.onInputChange.bind(this, 'fechaNacimiento')}
                                                    value={this.state.user.fechaNacimiento}
                                                />
                                            </div>
                                        </div>
                                        <div className={cx('col-md-12 form-group', 'form__control-label')}>
                                            <label className="col-sm-2 col-md-3 control-label">¿Foto inservible?</label>
                                            <div className="col-sm-2 col-md-2">
                                                <input
                                                    className="form-control"
                                                    type="checkbox"
                                                    id={this.state.index}
                                                    onChange={this.onIsWrong}
                                                    checked={this.state.files[this.state.index].is_wrong}
                                                    disabled={this.props.statusFiles === 'Aprobados' || !this.props.canApproveFiles}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <button className={cx("btn btn-sm btn-primary", 'btnModal')} onClick={this.handleSubmit}><span className="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span> Guardar</button>
                                            </div>
                                            <div className="col-md-3">
                                                <button className={cx("btn btn-sm btn-danger", 'btnModal')} onClick={() => this.onDeleteFile()} disabled={this.props.statusFiles === 'Aprobados'}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span> Eliminar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                                :
                                <div>
                                    <div className="col-md-5">
                                        <h5 className={css.textInfo}>Tipo Documento: {this.state.files[this.state.index].name_document}</h5>
                                    </div>
                                    <div className="col-md-4">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={this.state.index}
                                            onChange={this.onIsWrong}
                                            checked={this.state.files[this.state.index].is_wrong}
                                            disabled={this.props.statusFiles === 'Aprobados' || !this.props.canApproveFiles}
                                        />
                                        <label className="form-check-label" htmlFor="autoSizingCheck">
                                            Marque si la imagen no corresponde
                                        </label>
                                    </div>
                                    <div className="col-md-3">
                                        <button className={cx("btn btn-sm btn-danger pull-right", 'btnModal')} onClick={() => this.onDeleteFile()} disabled={this.props.statusFiles === 'Aprobados'}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span> Eliminar</button>
                                    </div>

                                    <img src={`${this.state.files[this.state.index].path}`} className={css.originalImage}/>
                                    <div className="col-md-12">
                                        <nav aria-label="...">
                                            <ul className="pager">
                                                <li>
                                                    <a className={css.btnModal} onClick={() => this.previusFile()}>
                                                        <span className="glyphicon glyphicon-arrow-left" aria-hidden="true"/>
                                                        Anterior
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className={css.btnModal} onClick={() => this.nextFile()}>
                                                        Siguiente
                                                        <span className="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            }
                        </div>
                        :
                        <div>
                            <img src={`/imagen_404.png`} className={css.originalImage}/>
                        </div>
                    }
                    <div className="row" onKeyDown={this.onKeyPressed} tabIndex="0">
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-btn-default" onClick={this.props.hideModal}>Cerrar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalReviewFiles.contextTypes = {
    isWrongFile: PropTypes.func,
}

export class ModalHistorial extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            nominas: [],
            nombre: '',
            done: false
        }
    }
    componentWillMount(){
        this.props.verHistorial()
            .then(historial=>{
                this.setState({
                    nombre: historial.nombre,
                    nominas: historial.nominas,
                    done: true
                })
            })
            .catch(error=>{
                console.error(error)
            })
    }
    render(){
        return(
            <Modal show={true} onHide={this.props.hideModal} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Historial de nominas {this.state.nombre!=''? ` de ${this.state.nombre}` : ''}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Cargo</th>
                                <th>Local</th>
                            </tr>
                        </thead>
                        <tbody>
                        {this.state.done?
                            (this.state.nominas.length>0?
                                this.state.nominas.map((nom, index)=>
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{nom.fecha}</td>
                                        <td>{nom.role}</td>
                                        <td>{nom.inventario}</td>
                                    </tr>
                                )
                                :
                                <tr>
                                    <td>No tiene inventarios registrados</td>
                                </tr>
                            )
                            :
                            <tr>
                                <td>Cargando..</td>
                            </tr>
                        }

                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-btn-default" onClick={this.props.hideModal}>Cerrar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/MantenedorPersonal/Modales.jsx